import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import { DataSourceFolderWithSubfoldersSchema } from './data-sources-folders.schema';

const { DATA_SOURCE } = PERMISSIONS;

/**
 * REST contract for DataSourceFolder operations
 */
export const DataSourceFoldersContract = createRESTContract({
  /**
   * Get all DataSourceFolders with nested subfolders and counts
   */
  getAllDataSourceFoldersWithSubfolders: {
    method: 'GET',
    path: '/data-sources-folders/with-subfolders',
    permissions: [DATA_SOURCE.DATA_SOURCE_LIST],
    response: z.array(DataSourceFolderWithSubfoldersSchema),
  },
});
